import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Card from "./MynftCard";
import { ToastContainer, toast } from 'react-toastify';
import Web3 from "web3";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
//const [globenft , setglobenft] = useState([]);
var config = require("../../src/config/dev").default;


function MyAssetNftRow(props){
    console.log("props",props);
    const ID = sessionStorage.getItem("metamaskId");
    console.log("ID",ID);
    let ownerArr =[];
    let Array1 = [];
    let Array2 = [];
    let Array3 = [];
    // let metamaskId = "";
    let AlgoId = "";
    // let owners = [];
    const [alertDisplayed, setAlertDisplayed] = useState(false);
    const [errorToastShown, setErrorToastShown] = useState(false); // State to track if error toast is shown
    let [metamaskId,setMetamaskId] = useState([]);
    let [metamaskIdnew,setMetamaskIdnew] = useState("");
    const [metamaskIdInitialized, setMetamaskIdInitialized] = useState(false); // Track initialization
    const [EPRnfts,setEPRNfts] = useState([]);
    const [error, setError] = useState(null);
    let nfts = [];
    let metamask = [];
    let [nftresponse,setNftresponse] = useState([]);
    const [walletAddress, setWalletAddress] = useState("");
    let [owners,setOwners] = useState([]);
    const [cbdcWalletId, setCbdcWalletId] = useState(localStorage.getItem("buyerCbdcWalletId") || "");
    const [cbdcBalance, setCbdcBalance] = useState(null);
    const [cbdcCurrency, setCbdcCurrency] = useState("TRC-TOKEN");

    useEffect(() => {
      const walletId = localStorage.getItem("buyerCbdcWalletId");
      if (!walletId) return;
      fetch(config.API_ENDPOINT + `api/v1/cbdc/wallet/balance?walletId=${encodeURIComponent(walletId)}`, {
        headers: { "x-api-token": sessionStorage.getItem("traceChainAccessToken") }
      })
        .then(r => r.json())
        .then(data => {
          if (data.success) {
            setCbdcBalance(data.data?.balance ?? null);
            setCbdcCurrency(data.data?.currency || "TRC-TOKEN");
          }
        })
        .catch(() => {});
    }, []);

    useEffect(()=>{
    const run = async () => {
   
        
    const handleConfirmPurchaseClick = async () => {

        try{
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

          if (typeof window.ethereum !== "undefined") {
            const chainId = await window.ethereum.request({
              method: "eth_chainId",
            });
            if (chainId !== "0x13882") {
              console.log("Please switch to the Polygon Testnet network");
              return;
            }
            // Use deep link on mobile or request accounts directly on desktop
            if (isMobile) {
                window.open("https://metamask.app.link/dapp/" + window.location.href, "_blank");
            } else {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
            }
            const web3 = new Web3(window.ethereum);
            const accounts = await web3.eth.getAccounts();
            const from = accounts[0];
            console.log("from address",from);
            let metamaskId1 = from;
            metamaskIdnew = from;
            setMetamaskIdnew(from)
            
            setMetamaskIdInitialized(true);
            if(metamaskIdInitialized == true){
                metamaskIdnew = from;
            }
            console.log("metamaskId",metamaskId1);
            console.log("metamaskIdnew",metamaskIdnew);
            metamask.push(from);
            console.log("metamask".metamask);
            // metamaskId = metamaskId1;
            setMetamaskId(metamaskId1)
            console.log("setMetamaskId",metamaskId);
        } else if (isMobile) {
            window.open("https://metamask.app.link/dapp/" + window.location.href, "_blank");
        } else {
            console.log("Please install MetaMask");
        }
    } catch (error) {
        console.error(error);
      }
}
        
        const fetchNft= async()=>{
            const nftResult = await axios.get(config.API_ENDPOINT+'src/v1/nftdetails', {
                
                headers: {                      
                    'X-Api-token':sessionStorage.getItem('traceChainAccessToken')          
                },
                // params:{
                //   tokenId: "",
                //   owner:"0xA753ee0104E2e19AD2502d71c1A92b4cc499B182"
                // }
            })
            
           
            .then(async (res) => {
                const newArray = res.data.data.result;
                nfts.push(newArray)
                console.log("nfts",nfts);
                // const newArray1 = nfts; 
                // setnftresponse(nfts);
                setNftresponse([nfts]);
                // nftresponse = nfts;
                console.log("nftresponse",nftresponse);
                nfts?.map((nft) => {
                    console.log("nft43",nft);
                    
                    return nft?.map((nftcopy1) => {
                         nftcopy1?.nft_sale.map( (nftcopy2) => {
                           Array1.push(nftcopy2);
                           
                        //    setTimeout(async () => {
                           const newArr =  Array1.filter(element => element.owner == metamaskId)
                           Array2.push(newArr);
                        //    console.log("Array2",Array2);
                               setTimeout(async () => {
                           const newArrr2 = Array1.filter(element => element.owner == AlgoId)
                        //    console.log("newArrr2",newArrr2)
                           Array3.push(newArrr2);
                           },5000);

                              
                       })
                     })  
                   })
                console.log("Array1",Array1);
                console.log("Array2",Array2);
                console.log("Array3",Array3);
                const lastIndex = Array2.length - 1;
                const lastObject = Array2[lastIndex];
                console.log("lastObj",lastObject);
                // owners.push(lastObject);
                setOwners([lastObject]);
                console.log("owners",owners);
                console.log("NFT API REsponse handleConfirm",nftResult)
            })
            .catch((err)=>{
                console.log(err);
            })
    
        }

        const fetchEPRNft = async () =>{
          
           
                 console.log("api",config.API_ENDPOINT);
                await axios.get(config.API_ENDPOINT+'src/v1/eprnftdetails', {
                  
                    headers: {
                    'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                    },
                    
    
                })
                
                .then((res) => {
                  
                  console.log("in EPR API");
                    const EPRnftResult = res.data.data.result;
                    EPRnftResult.forEach(async element => { 
                      element.assetType = "EprAsset"
                    })
                    console.log("eprData",EPRnftResult);
                    setEPRNfts(EPRnftResult);
    
                    
                    
                })
                  
            };
            await fetchEPRNft();
        
       await fetchNft();
    
        // handleConfirmPurchaseClick();
        checkwithAlgos(); //for algosigner popup
    };
    run();

    },[]

    );


//     const handleConfirmPurchaseClick = async () => {
    
//         try {
//           // Check if MetaMask is installed
//           if (typeof window.ethereum !== "undefined") {
//             // Check if the network is Polygon Testnet
//             const chainId = await window.ethereum.request({
//               method: "eth_chainId",
//             });
//             // if (chainId !== "0x13881") {
//                 if (chainId !== "0x13882") {
//               console.log("Please switch to the Polygon Testnet network");
//               return;
//             }
//             // Enable user account access
//             await window.ethereum.enable();
//             // Create Web3 instance
//             const web3 = new Web3(window.ethereum);
//             // Get the selected account
//             const accounts = await web3.eth.getAccounts();
//             const from = accounts[0];
//             console.log("from address",from);
//             let metamaskId1 = from;
//             metamaskIdnew = metamaskId1;
//             // metamaskIdnew.push(metamaskId1);
//             setMetamaskIdnew(metamaskIdnew)
//             console.log("metamaskId",metamaskId1);
//             console.log("metamaskIdnew",metamaskIdnew);
//             // metamaskId = metamaskId1;
//             setMetamaskId(metamaskId1)
//             console.log("setMetamaskId",metamaskId);
//         }
//     }catch (error) {
//         console.error(error);
//       }
// }

const checkwithAlgos = async() => {
    console.log("Inside buywith algo");
    try {
        const connection = await AlgosignerUtility.checkAlgoSignerWallet1(true);
        console.log("connection------",connection);

        AlgoId = connection;
        console.log("AlgoId", AlgoId);

        if (!connection) {
            console.log("Inside IF");
            return;
        }
    }catch (err) {
        console.log(err.message);
    }
}



 return(
    
    <div className="row mb-4 mt-1">
         <div className="row" >


         {error && (
            <div className="error-message">
                {error}
            </div>
          )}
{/* ─── MetaMask / Polygon sections — only when NO CBDC wallet is connected ── */}
{!cbdcWalletId && (
    <>
        {/* MetaMask connected banner */}
        {metamaskIdnew && (
            <div style={{
                width:"100%", margin:"0 0 8px 0",
                background:"#f97316", color:"#fff",
                borderRadius:"8px", padding:"10px 18px",
                display:"flex", alignItems:"center", gap:"10px", fontSize:"13px"
            }}>
                <span style={{fontSize:"18px"}}>🦊</span>
                <span><b>MetaMask Connected:</b> {metamaskIdnew}</span>
            </div>
        )}

        {/* ── MetaMask EPR NFTs ── */}
        <button className="assetrowbutton">MY EPR NFTs</button>
        {EPRnfts.map((nft) => {
            return nft.nft_sale.map((nftcopy1) => {
                if (nftcopy1.owner == metamaskId && nftcopy1.ownedCopies > 0 && nft.network_type !== "hyperledger" && !/^trc-cbdc-/i.test(nftcopy1.owner || "")) {
                    return (
                        <div key={nftcopy1._id} className="col-3" style={{padding:"0% 1%"}}>
                            <Card
                                ownerName={nft.nft_sale[0].ownerName}
                                assetType="EPRAsset"
                                owner={nftcopy1.owner}
                                totalcopy={nft.no_of_copies}
                                UOM={nft.eprAssetUom}
                                quantity={nftcopy1.ownedCopies}
                                saleCopy={nftcopy1.sale_copies}
                                price={nftcopy1.fixedPrice}
                                image_link={nft.assetImg}
                                desc=""
                                token_id={nft.tokenId}
                                name={nft.assetName}
                                assetId={nft.assetId}
                                certNumber={nft.certNumber}
                                token_address={nft.token_address}
                                network_type={nft.network_type}
                            />
                        </div>
                    );
                }
                return null;
            });
        })}

        {/* ── MetaMask Non-EPR NFTs ── */}
        <button className="assetrowbutton">MY NFTs</button>
        {ID ? (
            nftresponse.map((nft) => {
                return nft[0].map((nftcopy1) => {
                    return nftcopy1.nft_sale.map((nftcopy2) => {
                        const lowercasemetamaskId = metamaskIdnew.toLowerCase();
                        if (nftcopy2.owner === lowercasemetamaskId && nftcopy2.ownedCopies > 0 && nftcopy1.network_type !== "hyperledger" && !/^trc-cbdc-/i.test(nftcopy2.owner || "")) {
                            return (
                                <div key={nftcopy2._id} className="col-3" style={{padding:"0% 1%"}}>
                                    <Card
                                        ownerName={nftcopy1.nft_sale[0].ownerName}
                                        assetType="NonEPRAsset"
                                        owner={nftcopy2.owner}
                                        totalcopy={nftcopy1.no_of_copies}
                                        UOM={nftcopy1.eprAssetUom}
                                        quantity={nftcopy2.ownedCopies}
                                        saleCopy={nftcopy2.sale_copies}
                                        price={nftcopy2.fixedPrice}
                                        image_link={nftcopy1.assetImg}
                                        desc=""
                                        token_id={nftcopy1.tokenId}
                                        name={nftcopy1.assetName}
                                        assetId={nftcopy1.assetId}
                                        token_address={nftcopy1.token_address}
                                        network_type={nftcopy1.network_type}
                                    />
                                </div>
                            );
                        }
                        return null;
                    });
                });
            })
        ) : null}
    </>
)}
{/* ─── CBDC / Hyperledger Fabric NFTs ─────────────────────────────────── */}
{cbdcWalletId ? (
    <>
        {/* Connected wallet banner */}
        <div style={{
            width:"100%", margin:"4px 0 8px 0",
            background:"#001F60", color:"#fff",
            borderRadius:"8px", padding:"10px 18px",
            display:"flex", alignItems:"center", gap:"10px", fontSize:"13px",
            flexWrap:"wrap"
        }}>
            <span style={{fontSize:"18px"}}>💳</span>
            <span style={{flex:1, minWidth:0}}><b>CBDC Wallet:</b> <span style={{fontFamily:"monospace", fontSize:"12px", opacity:0.85}}>{cbdcWalletId}</span></span>
            {cbdcBalance !== null && (
              <span style={{background:"rgba(255,255,255,0.15)", borderRadius:"6px", padding:"3px 10px", fontWeight:"700", fontSize:"13px", whiteSpace:"nowrap"}}>
                ₹{Number(cbdcBalance).toLocaleString()} {cbdcCurrency}
              </span>
            )}
        </div>

        {/* CBDC EPR NFTs */}
        <button className="assetrowbutton">MY CBDC EPR NFTs</button>
        {EPRnfts.map((nft) =>
            nft.nft_sale.map((sale) => {
                if (sale.owner && sale.owner.toLowerCase() === cbdcWalletId.toLowerCase() && sale.ownedCopies > 0) {
                    return (
                        <div key={sale._id} className="col-3" style={{padding:"0% 1%"}}>
                            <Card
                                ownerName={nft.nft_sale[0].ownerName}
                                assetType="EPRAsset"
                                owner={sale.owner}
                                totalcopy={nft.no_of_copies}
                                UOM={nft.eprAssetUom}
                                quantity={sale.ownedCopies}
                                saleCopy={sale.sale_copies}
                                price={sale.fixedPrice}
                                image_link={nft.assetImg}
                                desc=""
                                token_id={nft.tokenId}
                                name={nft.assetName}
                                assetId={nft.assetId}
                                certNumber={nft.certNumber}
                                token_address={nft.token_address}
                                network_type={nft.network_type}
                            />
                        </div>
                    );
                }
                return null;
            })
        )}

        {/* CBDC Non-EPR NFTs */}
        <button className="assetrowbutton">MY CBDC NFTs</button>
        {nftresponse.map((nftGroup) =>
            nftGroup[0]?.map((nftcopy1) =>
                nftcopy1.nft_sale.map((sale) => {
                    if (sale.owner && sale.owner.toLowerCase() === cbdcWalletId.toLowerCase() && sale.ownedCopies > 0) {
                        return (
                            <div key={sale._id} className="col-3" style={{padding:"0% 1%"}}>
                                <Card
                                    ownerName={nftcopy1.nft_sale[0].ownerName}
                                    assetType="NonEPRAsset"
                                    owner={sale.owner}
                                    totalcopy={nftcopy1.no_of_copies}
                                    UOM={nftcopy1.eprAssetUom}
                                    quantity={sale.ownedCopies}
                                    saleCopy={sale.sale_copies}
                                    price={sale.fixedPrice}
                                    image_link={nftcopy1.assetImg}
                                    desc=""
                                    token_id={nftcopy1.tokenId}
                                    name={nftcopy1.assetName}
                                    assetId={nftcopy1.assetId}
                                    token_address={nftcopy1.token_address}
                                    network_type={nftcopy1.network_type}
                                />
                            </div>
                        );
                    }
                    return null;
                })
            )
        )}
    </>
) : (
    <div style={{
        width:"100%", margin:"18px 0", padding:"12px 18px",
        background:"#f0f2f8", borderRadius:"8px",
        color:"#001F60", fontSize:"13px", border:"1px dashed #001F60"
    }}>
        No CBDC Wallet connected. Generate or enter your CBDC Wallet ID on the asset purchase page to see your Hyperledger Fabric NFTs here.
    </div>
)}

<ToastContainer/>
    </div>

    </div>

 )
}


export default MyAssetNftRow;
